module.exports = __webpack_public_path__ + "img/zw.1e5f7ac6.svg";